import { LANG_DEFAULT } from 'constant';
import { atom, selector } from 'recoil';

export const systemInfoAtom = atom<any>({
  key: 'systemInfoAtom',
  default: {
    language:
      JSON.parse(localStorage.getItem('myPagePreference') ?? '{}')?.language ??
      LANG_DEFAULT,
  },
});

export const onChangeLangAtom = selector({
  key: 'onChangeLangAtom',
  get: ({ get }) => get(systemInfoAtom),
  set: ({ set, get }, language) => {
    const systemInfo = get(systemInfoAtom);
    set(systemInfoAtom, { ...systemInfo, language });
  },
});
